import { flattenToAppURL } from '@plone/volto/helpers';
import maplibregl from 'maplibre-gl';
// import mlcontour from 'maplibre-contour';

export async function flyTrack(map, gj, gtyp, ofly=null) {
  console.log('gj=', gj, 'gtyp=', gtyp);
  let curve = 1.42;
  let speed = 1.2;
  if (ofly === null) {
    ofly = {
      zoom: map.getZoom(),
      speed: 0.1,
      inc: 1,
    }
  }
  for (let feat of gj?._data?.features) {
    if( feat.geometry?.type == gtyp ) {
      const track = feat.geometry.coordinates;
      for (let i=0; i<track.length; i+=ofly.inc) {
	let loc = track[i];
        let fly = {
	  center: [loc[0], loc[1]],
	  // pitch: parseFloat(params.get('flypit')) || map.current.getPitch(),
	  // bearing: parseFloat(params.get('flybea')) || map.current.getBearing(),
	  speed: speed,
	  zoom: ofly.zoom,
	  curve: curve,
	  easing(t) { return t },
	  essential: true,
	};
	if ( map.isMoving() ) {
	  await map.once('moveend');
	  if ( map._endfly ) {
	    return;
	  }
	  map.flyTo(fly);
	}
	curve = 0.2; // 1.42;
	speed = ofly.speed;
      }
    }
  }
}

function addTrack(map, fn, gj_data) {
  console.log('addTrack fn=',fn);
  map.addSource(fn, {
    type: "geojson",
    data: gj_data
  });
  // Use the geoJSON to add the layer
  map.addLayer({
    id: fn+"track",
    type: "line",
    source: fn,
    layout: {
      "line-join": "round",
      "line-cap": "round"
    },
    paint: {
      "line-color": "#00b",
      "line-width": 5
    }
  });
}
export async function getGpx(map, fn) {
  try {
    const resp = await fetch(fn, { headers: { 'Accept': 'application/xml' } });
    if (resp.ok) {
      const parser = new window.DOMParser();
      const mytxt = await resp.text();
      const mygpx = parser.parseFromString(mytxt, "application/xml");
      const mygj = gpx2gj(mygpx, fn);
      addTrack(map, fn, mygj);
    } else {
      throw new Error(resp.status);
    }
  } catch (err) {
    console.log(`Error reading "${fn}": ${err}`);
  }
}

export async function getGeoJson(map, fn) {
  const resp = await fetch(fn, {
    headers: {
      'Accept': 'application/json'
    }
  });
  const myjson = await resp.json();
  // console.log('fn=', fn, 'myjson=', myjson);
  map.addSource(fn, {
    "type": "geojson",
    "data": myjson
  });
  map.addLayer({
    "id": fn+"track",
    "type": "line",
    "source": fn,
    "layout": {
      "line-join": "round",
      "line-cap": "round"
    },
    "paint": {
      "line-color": ["coalesce", ["get", "stroke"], "pink"],
      "line-width": ["coalesce", ["get", "stroke-width"], 5],
      "line-opacity": ["coalesce", ["get", "stroke-opacity"], 0.6]
    },
    "filter": [
      "==", "$type", "LineString" ]
  });
  map.addLayer({
    "id": fn+"poly",
    "type": "fill",
    "source": fn,
    "paint": {
      "fill-color": ["coalesce", ["get", "stroke"], "orange"],
      "fill-opacity": ["coalesce", ["get", "stroke-opacity"], 0.4]
    },
    "filter": [ "==", "$type", "Polygon" ]
  });
  map.addLayer({
    "id": fn+"feat",
    "type": "symbol",
    "source": fn,
    "layout": {
      "icon-image": ["coalesce", ["get", "typ"], "photo"],
      "icon-overlap": "always"
    },
    "filter": [ "==", "$type", "Point" ]
  });
  const popup = new maplibregl.Popup({
    closeButton: true,
    closeOnClick: true
  });
  map.on('click', fn+'feat', (e) => {
    const coordinates = e.features[0].geometry.coordinates.slice();
    const description = e.features[0].properties.popupContent || '';
    // Ensure that if the map is zoomed out such that multiple
    // copies of the feature are visible, the popup appears
    // over the copy being pointed to.
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    }
    //popup.remove();
    //new maplibregl.Popup()
    popup.setLngLat(coordinates)
      .setHTML(description)
      .addTo(map);
  });
  // Change the cursor to a pointer when the mouse is over the places layer.
  map.on('mouseenter', fn+'feat', (e) => {
    map.getCanvas().style.cursor = 'pointer';
    const description = e.features[0].properties.tooltipContent;
    if (description) {
      const coordinates = e.features[0].geometry.coordinates.slice();
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
	coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }
      popup.setLngLat(coordinates).setHTML(description).addTo(map);
    }
  });
  // Change it back to a pointer when it leaves.
  map.on('mouseleave', fn+'feat', () => {
    map.getCanvas().style.cursor = '';
  });
}

export const customIcons = {};
export async function processIPFolder(map, url) {
  //const uri = '/++api++/'+url.replace(location.origin, '');
  const uri = '/++api++/'+flattenToAppURL(url);
  // console.log('uri=', uri);
  const resp = await fetch(uri, {
    headers: {
      'Accept': 'application/json'
    }
  });
  const ip_folder = await resp.json();
  if(ip_folder) {
    for( let itm in ip_folder.items) {
      let nam = ip_folder.items[itm]['@id']
      if( nam.endsWith('.png') ) {
	let beg = nam.lastIndexOf('/');
	let icon_name = nam.slice(beg+1, -4); // just the base file name
	// console.log('nam=', nam, 'uri=', uri, 'icon_name=', icon_name);
	customIcons[icon_name] = await map.loadImage(
	  nam + "/@@images/image/icon");
	map.addImage(icon_name, customIcons[icon_name].data);
      }
    }
  }
}

export async function processGJFolder(map, url) {
  if ( ! url ) return;
  // const uri = '/++api++/' + url.replace(location.origin,'');
  const uri = '/++api++/'+flattenToAppURL(url);
  const resp = await fetch(uri, {
    headers: {
      'Accept': 'application/json'
    }
  });
  const js_folder = await resp.json();
  if(js_folder) {
    for( let itm in js_folder.items) {
      const nam = js_folder.items[itm]['@id']
      if( nam.endsWith('.json') )
	getGeoJson(map, nam + "/@@download/file" );
      if( nam.endsWith('.gpx') )
	getGpx(map, nam + "/@@download/file" );
    }
  }
}
export async function addTopo(map) {
  // From: https://maplibre.org/maplibre-gl-js/docs/examples/contour-lines/
  const contourjs = import('maplibre-contour');
  const demURL = 'https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png'; // This value should be from data.demURL
  contourjs.then( mlcontour => {
    const demSource = new mlcontour.default.DemSource({
      url: demURL,
      "encoding": "terrarium",
      maxzoom: 12,
      worker: true // offload contour line computation to a web worker
    });
    // calls maplibregl.addProtocol to register a dynamic vector tile provider
    // that downloads raster-dem tiles, computes contour lines, and encodes
    // as a vector tile for each tile request from maplibre
    demSource.setupMaplibre(maplibregl);
    map.on('load', () => {
      map.addSource("contourSourceFeet", {
	type: 'vector',
	tiles: [
          demSource.contourProtocolUrl({
            // meters to feet
            multiplier: 3.28084,
            overzoom: 1,
            thresholds: {
	      // zoom: [minor, major]
	      11: [200, 1000],
	      12: [100, 500],
	      13: [100, 500],
	      14: [50, 200],
	      15: [20, 100]
            },
            elevationKey: 'ele',
            levelKey: 'level',
            contourLayer: 'contours'
          })
	],
	maxzoom: 15
      });
      map.addLayer({
	id: 'contours',
	type: 'line',
	source: 'contourSourceFeet',
	'source-layer': 'contours',
	paint: {
          'line-opacity': 0.5,
          // "major" contours have level=1, "minor" have level=0
          'line-width': ['match', ['get', 'level'], 1, 1, 0.5]
	}
      });
      map.addLayer({
	id: 'contour-text',
	type: 'symbol',
	source: 'contourSourceFeet',
	'source-layer': 'contours',
	filter: ['>', ['get', 'level'], 0],
	paint: {
          'text-halo-color': 'white',
          'text-halo-width': 1
	},
	layout: {
          'symbol-placement': 'line',
          'text-size': 10,
          'text-field': [
            'concat',
            ['number-format', ['get', 'ele'], {}],
            "\'"
          ],
          "text-font": ["Noto Sans Regular"],
	}
      });
    });
  });
}

// From: https://observablehq.com/@mcmcclur/gpx-rides-with-maplibre-and-maptiler
// parseTime1 = d3.utcParse("%Y-%m-%dT%H:%M:%S.%LZ");
// parseTime2 = null //d3.utcParse("%Y-%m-%dT%H:%M:%SZ");
function parseTime(s) {
  let t1 = Date(s); //parseTime1(s);
  if (t1)
    return t1;
  return null; //parseTime2(s);
}
// parser = new DOMParser()
// Parse the GPX file and return a list of [lat,lon] points.
// Each point optionally has a ele(vation) and time keys.
function gpx2gj(gpx, fn) {
  let gj_data = {
    type: "FeatureCollection",
    features: []
  }
  var trk_num = 0;
  const metadata = gpx.getElementsByTagName("metadata");
  const meta_name = metadata[0]?.getElementsByTagName("name")[0].innerHTML || "";
  for (let trk of gpx.getElementsByTagName("trk")) {
    const trk_name = trk.getElementsByTagName("name")[0]?.innerHTML || meta_name;
    var seg_num = 0;
    for (let trkseg of trk.getElementsByTagName("trkseg")) {
      let trkpts = trkseg.getElementsByTagName("trkpt");
      let pts = [];
      for (let trkpt of trkpts) {
	let pt = [
	  parseFloat(trkpt.getAttribute("lon")),
	  parseFloat(trkpt.getAttribute("lat"))
	];
	try {
	  let ele = trkpt.getElementsByTagName("ele")[0].textContent;
	  pt.ele = 3.28084 * parseFloat(ele);
	} catch (e) {
	  ("pass");
	}
	try {
	  let time = trkpt.getElementsByTagName("time")[0].textContent;
	  pt.time = parseTime(time);
	} catch (e) {
	  ("pass");
	}
	pts.push(pt);
      }
      let lons = pts.map((pt) => pt[0]);
      pts.min_lon = Math.min(...lons);
      pts.max_lon = Math.max(...lons);
      let lats = pts.map((pt) => pt[1]);
      pts.min_lat = Math.min(...lats);
      pts.max_lat = Math.max(...lats);
      gj_data.features.push({
	type: "Feature",
	geometry: {
          type: "LineString",
          coordinates: pts
	},
	properties: {
	  name: `${trk_name} ${trk_num}.${seg_num}`,
	  title: `File: ${fn} Track: ${trk_name} Track#: ${trk_num}) Segment#: ${seg_num}`
	}
      });
      seg_num = seg_num + 1;
    }
    trk_num = trk_num + 1;
  }
  return gj_data;
}

//  ---- Nothing below here is used ----

async function setPopContent(uri, obj) {  // NOT YET USED
  fetch("/++api++/"+uri, {
    headers: {
      'Accept': 'application/json'
    }
  }).then(
    resp => resp.json()
  ).then (
    resp =>
    {
      obj.setContent(`
<div class="photo-marker">
  <h3>${uri}</h3>
  <A href="${uri}/@@images/image" target="_blank">
    <img src="${uri}/@@images/image/large">
  </A>
  <div class="photo-buttons">
    <A class="anonhide" href="${uri}/edit">[edit]</A>
  </div>
  <div class="photo-description">
    ${resp.description}
  </div>
</div>`);
    }
  )
};
